import { useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';
import { buildStockReturnLineColumns } from '#/modules/imsMgmt/receipts/stockReturn/columns/stockReturnLineColumns';

const StockReturnLinesTable = ({ lines = [] }) => {
  const columns = useMemo(() => buildStockReturnLineColumns(), []);

  const rows = useMemo(
    () => (lines ?? []).map((line, index) => ({
      ...line,
      id: line.id || line.invStock?.id
        ? `${line.id ?? line.invStock.id}-${index}`
        : `line-${index}`,
    })),
    [lines],
  );

  const detailTableState = useDetailTable(rows, columns, {
    enableExpanding: false,
    getRowId: (row) => String(row.id),
  });

  return (
    <div className="detail-table-container">
      <DetailTable
        state={detailTableState}
        containerClassName="detail-table-scroll--section-embedded"
        tableClassName="detail-table--flat-lines"
      />
    </div>
  );
};

StockReturnLinesTable.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.object),
};

export default StockReturnLinesTable;
